export default "__VITE_ASSET__YtLUgyHK__"